// Success mixin

import Swal from 'sweetalert2';

export const SwalSuccess = Swal.mixin({
    icon: 'success',
    title: 'Success'
});
